<template>
  <!-- Poster section: ONE big number — the years he stayed -->
  <section class="poster-place">
    <div class="poster-place__inner">
      <div class="part-label">The Place</div>
      <div class="poster-place__num">
        <span class="poster-num poster-num--mega">56</span>
        <span class="poster-label">years in one hamlet of <strong>449 people</strong>, between two Roman quarries</span>
      </div>
      <div class="poster-place__body">
        <p>
          Miseglia is a frazione of Carrara at 240 m elevation, balanced between the quarry
          canyons of Canale di Fantiscritti and Canalgrande. The Fantiscritti quarries take their
          name from a Roman-era bas-relief carved directly on the rock face. The Colonnata
          quarries nearby have been worked since <strong>the first century BC</strong>.
        </p>
        <p>
          Stroobant arrived in 1970 on a state scholarship and never left. Henry Moore, Hans Arp
          and Isamu Noguchi all worked Carrara marble at some point in their careers — none of
          them stayed.
        </p>
      </div>
    </div>

    <div class="poster-place__media">
      <img
        class="poster-place__img poster-place__img--main"
        src="/img/075c3d-carrara-colonnata-veduta-di-fossacava-cava-roman.webp"
        alt="Fossacava — a Roman quarry in continuous use since the 1st century BC"
      />
      <div class="poster-place__thumbs">
        <figure>
          <img
            src="/img/ab0890-carrara-marble-quarry-face.webp"
            alt="A Carrara quarry face"
          />
          <figcaption>A Carrara quarry face.</figcaption>
        </figure>
        <figure>
          <img
            src="/img/8d22b8-marble-caves-49606300321.webp"
            alt="The marble caves above Carrara"
          />
          <figcaption>The marble caves — tunnel quarries inside the mountain.</figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>

<style scoped>
.poster-place {
  position: relative;
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);
  align-items: stretch;
  background: var(--paper);
}
.poster-place__inner {
  padding: clamp(5rem, 14vh, 10rem) clamp(2rem, 5vw, 5rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
}
.poster-place__num {
  display: grid;
  gap: 0.8rem;
}
.poster-place__num .poster-num--mega {
  font-size: clamp(11rem, 22vw, 22rem);
}
.poster-place__body {
  max-width: 44ch;
  font-size: 1.2rem;
  line-height: 1.65;
  color: var(--slate-soft);
}
.poster-place__body p { margin: 0 0 1.2em; }
.poster-place__body strong { color: var(--slate); }
.poster-place__media { display: grid; grid-template-rows: 1.6fr 1fr; min-height: 100vh; }
.poster-place__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  min-height: 0;
}
.poster-place__thumbs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.4rem;
  background: var(--paper-deep);
}
.poster-place__thumbs figure { margin: 0; display: grid; }
.poster-place__thumbs img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  min-height: 28vh;
}
.poster-place__thumbs figcaption {
  position: relative;
  margin-top: -1.7rem;
  padding: 0.4rem 0.7rem;
  background: rgba(244, 241, 234, 0.85);
  font-size: 0.78rem;
  color: var(--slate-soft);
  line-height: 1.3;
  align-self: end;
}
@media (max-width: 900px) {
  .poster-place { grid-template-columns: 1fr; }
  .poster-place__media { min-height: auto; }
  .poster-place__img { min-height: 40vh; }
  .poster-place__thumbs img { min-height: 22vh; }
}
</style>
